import { getFirestore, type Firestore } from 'firebase/firestore';
import { firebaseApp } from './firebaseApp.js';

export const getFirebaseFirestore = (): Firestore | undefined => {
  if (!firebaseApp) return undefined;
  try {
    return getFirestore(firebaseApp);
  } catch {
    return undefined;
  }
};

export const firebaseFirestore = getFirebaseFirestore();
